import {
	useCallback,
	useContext
} from 'react';
import createDataContext from '../services/createDataContext';
import { mapLookupTypes } from '../services/utils';

import { getTagAuthScopes, getTagTypes } from '../api/nora/lookups';

import tagsReducer, {
	SET_TAG,
	SET_TAG_AUTH_SCOPES,
	SET_TAG_LIST,
	SET_TAG_TYPES
} from '../reducers/tagsReducer';

export let controller = new AbortController();

const initialState = {
	tagsList: [],
	tag: null,
	tagAuthScopes: [],
	tagTypes: []
};

// init functions
const setTagAuthScopes = async dispatch => {
	try {
		const [ { types } ] = await getTagAuthScopes( controller.signal );

		const typesToMap = types.map( ( {
			organizationID,
			name
		} ) => ( {
			id: organizationID,
			name
		} ) );

		const mappedTypes = mapLookupTypes( typesToMap );

		SET_TAG_AUTH_SCOPES( dispatch, controller.signal )( mappedTypes );
	} catch ( error ) {
		// handle
	}
};

const setTagTypes = async dispatch => {
	try {
		const [ { types } ] = await getTagTypes( controller.signal );

		const mappedTypes = mapLookupTypes( types );

		SET_TAG_TYPES( dispatch, controller.signal )( mappedTypes );
	} catch ( error ) {
		// handle
	}
};

const onInit = async dispatch => {
	controller = new AbortController();

	await setTagAuthScopes( dispatch );
	await setTagTypes( dispatch );
};

const onCleanup = () => {
	controller.abort();
};

export const {
	StateContext,
	ActionContext,
	Provider
} = createDataContext( {
	reducer: tagsReducer,
	initialState,
	controller,
	onInit,
	onCleanup
} );

export function useTagState() {
	const state = useContext( StateContext );

	return state;
}

export function useTagAction() {
	const dispatch = useContext( ActionContext );

	const clearTag = useCallback( () => {
		SET_TAG( dispatch, controller.signal )( null );
	}, [ dispatch ] );

	const setTag = useCallback( data => {
		SET_TAG( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	const setTagList = useCallback( data => {
		SET_TAG_LIST( dispatch, controller.signal )( data );
	}, [ dispatch ] );

	return {
		clearTag,
		setTag,
		setTagList
	};
}
